export default __webpack_public_path__ + "static/media/cybercats.2564ceb1.png";